import { X, Check } from "lucide-react";
import { Chapter, Reveal } from "./Shared";

const ROWS = [
  ["Finding inspiration", "Give us the brief"],
  ["Generating files", "We create original artwork"],
  ["Fixing AI mistakes", "We quality-check everything"],
  ["Preparing transparent backgrounds", "Production-ready PNG delivered"],
  ["Organising exports", "Organised delivery to your dashboard"],
];

export default function CompetitorComparison() {
  return (
    <section id="why-switch" data-testid="comparison-section" className="relative">
      <div className="mx-auto max-w-4xl px-6 py-16 sm:py-20">
        <Reveal className="text-center">
          <Chapter num="04" label="Why Switch" className="justify-center" />
          <h2 className="mt-6 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Why Etsy Sellers Switch
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="comparison-table"
            className="mt-12 overflow-hidden rounded-3xl border border-white/10 bg-[#0C1222]/80"
          >
            <div className="grid grid-cols-2">
              <div className="border-b border-r border-white/10 bg-[#070B14]/70 px-4 py-4 text-center sm:px-6">
                <p className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-rose-300 sm:text-xs">
                  DIY or AI Tools
                </p>
              </div>
              <div className="border-b border-white/10 bg-amber-400/10 px-4 py-4 text-center sm:px-6">
                <p className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-amber-300 sm:text-xs">
                  Your Grapho Studio
                </p>
              </div>
            </div>
            {ROWS.map(([them, us], i) => (
              <div key={them} className={`grid grid-cols-2 ${i !== ROWS.length - 1 ? "border-b border-white/5" : ""}`}>
                <div className="flex items-start gap-2.5 px-4 py-4 sm:px-6">
                  <X className="mt-0.5 h-3.5 w-3.5 shrink-0 text-rose-400/80" />
                  <p className="text-[13px] leading-snug text-slate-400">{them}</p>
                </div>
                <div className="flex items-start gap-2.5 bg-amber-400/[0.04] px-4 py-4 sm:px-6">
                  <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-400" />
                  <p className="text-[13px] font-medium leading-snug text-slate-200">{us}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}